import React, {Component} from 'react';
import styled from 'styled-components'
import defaultCoLogo from '../static/img/co.svg'
import defaultProfilePic from '../static/img/profile.svg'

const ProfileHoverContainer = styled.div`
width: 100%;
height: 100%;
background-color: rgba(46,46,46,0.66);
position: absolute;
display: none;
`


const ProfileContainer = styled.div`
width: 45vw;
height: 45vw;
border: 5px solid white;
border-radius: 50%;
margin: 0 auto;
display: block;
overflow: hidden;
box-sizing: border-box;
box-shadow: 0px -4px 20px rgba(0,0,0,0.25);
position: relative;

&:hover ${ProfileHoverContainer} {
display: block;
}
`



const ProfileImg = styled.img`
width: 100%;
height: 100%;
object-fit: cover;

`


class DropzoneProfilePicture extends Component {
    render() {
        return (
            <ProfileContainer>
                <ProfileHoverContainer/>
                {this.props.company ?
                    this.props.company.companyImgUrl ?
                        <ProfileImg src={this.props.company.companyImgUrl} alt="companyLogo"/>
                        :
                        <ProfileImg src={defaultCoLogo} alt="companyLogo"/>

                    :
                    null
                }
                {this.props.profile ?
                    this.props.profile.profileImgUrl ?
                        <ProfileImg src={this.props.profile.profileImgUrl} alt="profileImg"/>
                        :
                        <ProfileImg src={defaultProfilePic} alt="profileImg"/>

                    :
                    null
                }
            </ProfileContainer>
        )
    }
}

export default DropzoneProfilePicture;